import { render, staticRenderFns } from "./UpdateBatchAssignForm.vue?vue&type=template&id=e17dce96&scoped=true"
import script from "./UpdateBatchAssignForm.vue?vue&type=script&lang=js"
export * from "./UpdateBatchAssignForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateBatchAssignForm.vue?vue&type=style&index=0&id=e17dce96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17dce96",
  null
  
)

export default component.exports